import {css} from "styled-components";

/**
 * The outlined frame the sender's two "add something" pairs share (owner 2026-09-15, ui#1314):
 * "Add your files" / "Add a folder" in the empty drop area ({@link ./AddHero.styles}) and the
 * add-more pair under the file list ({@link ./FileSummary.styles}).
 *
 * One fragment rather than the same declarations typed twice, because the pairs have to read as the
 * same control in two places — the empty card and the filled one are the same choice at two moments,
 * and a border that drifted in either would say they were different things. Size, type and radius
 * stay with each call site: those genuinely differ (a 14px hero control against a 12.5px row).
 *
 * A SINGLE-LINE border, not dotted (owner, after seeing a dotted round on the preview). The colour is
 * the accent the dashed drop surface already uses, so the controls belong to the same family as the
 * surface around them, and the fill is left transparent so the hero's own tint shows through rather
 * than being covered by a second one. Ink follows the mode for contrast: the light accent is too dark
 * to read on a dark card, which is what `segInk` exists for.
 *
 * `box-sizing` is explicit because this repo has no global reset — without it the border would be
 * added OUTSIDE the 44px minimum and the touch target would quietly become 46px.
 */
export const outlinedControl = css`
	box-sizing: border-box;
	/* The phone touch minimum; see FileSummary.styles AddRow for why it is paid for out of margin. */
	min-height: 44px;
	border: 1px solid ${({theme}) => theme.tokens.blue};
	background: transparent;
	color: ${({theme}) => theme.tokens.mode === "dark" ? theme.tokens.segInk : theme.tokens.blue};
	cursor: pointer;
	font-family: inherit;
	transition: background 140ms ease;

	&:hover {
		background: ${({theme}) => theme.tokens.field};
	}

	&:focus-visible {
		outline: 2px solid ${({theme}) => theme.tokens.focusOutline};
		outline-offset: 2px;
	}
`;
